import App from 'app/app.js';

var ShoppingCartConstants = {
  subjectJobNumberMap: ['portraitDashboard', 'event'],
  REPRICE_DEBOUNCE_MS: 200
};

App.constant('ShoppingCartConstants', ShoppingCartConstants);
